import type {
    JSX,
} from "preact";
import {
    forwardRef,
} from "preact/compat";

type InputProps = JSX.InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
    ({
        className = "",
        ...props
    }, ref) => {
        return (
            <input
                ref={ref}
                className={`
                    px-3 py-2 rounded bg-bg-secondary border border-border
                    text-text-primary placeholder:text-text-muted
                    focus:border-accent focus:ring-1 focus:ring-accent focus:outline-none
                    transition-colors duration-200
                    disabled:opacity-50 disabled:cursor-not-allowed
                    ${className}
                `.trim().replace(/\s+/g, " ")}
                {...props}
            />
        );
    },
);

type TextAreaProps = JSX.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
    ({
        className = "",
        ...props
    }, ref) => {
        return (
            <textarea
                ref={ref}
                className={`
                    px-3 py-2 rounded bg-bg-secondary border border-border
                    text-text-primary placeholder:text-text-muted
                    focus:border-accent focus:ring-1 focus:ring-accent focus:outline-none
                    transition-colors duration-200
                    disabled:opacity-50 disabled:cursor-not-allowed
                    resize-y min-h-[80px]
                    ${className}
                `.trim().replace(/\s+/g, " ")}
                {...props}
            />
        );
    },
);
